import React from 'react';
import classnames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const InLineItem = _ref => {
  let {
    heading,
    boldHeading,
    value,
    boldValue,
    largeValueSize,
    helpText,
    deliveryText
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style.inLineWrapper,
    "data-id": "in-line-items_in-line-item_InLineItem_div",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.headingHelpTextWrapper,
      "data-id": "in-line-items_in-line-item_InLineItem_div_div_1",
      children: [/*#__PURE__*/_jsx(Paragraph, {
        className: classnames(style.heading, {
          [style.boldText]: boldHeading
        }),
        "data-id": "in-line-items_in-line-item_InLineItem_div_Paragraph",
        children: heading
      }), helpText && /*#__PURE__*/_jsx(Paragraph, {
        className: style.helpText,
        "data-id": "in-line-items_in-line-item_InLineItem_Paragraph_3",
        children: helpText
      }), deliveryText && /*#__PURE__*/_jsx(Paragraph, {
        className: style.helpText,
        "data-id": "in-line-items_in-line-item_InLineItem_Paragraph_4",
        children: deliveryText
      })]
    }), /*#__PURE__*/_jsx(Paragraph, {
      className: classnames(style.value, {
        [style.boldText]: boldValue,
        [style.largeText]: largeValueSize
      }),
      "data-id": "in-line-items_in-line-item_InLineItem_div_Paragraph_5",
      children: value
    })]
  });
};

export default InLineItem;